import SERVICE_URL from "../config/API_DATA";
import HttpPost from "../http/httppost.js";
import Logger from "./logger.js";
import { FILE_NAME, LOG_TYPE } from "../config/API_DATA";
import { DATE_TIME_FORMAT } from "../util/constants.js";
import { formatDate } from "../util/date/dateFunctions.js"
export default class HotelPolicy {
  static buildRequest(pHotelId,pCancelPolicy) {
    let returnValue = null;
    try {
      let body = {
        hotelId: pHotelId,
        roomId: pCancelPolicy.roomId.roomid,
        ratePlan: pCancelPolicy.ratePlan.id,
        validFrom: formatDate(pCancelPolicy.validFrom,DATE_TIME_FORMAT.API_DATE_FORMAT),
        validTo: formatDate(pCancelPolicy.validTo,DATE_TIME_FORMAT.API_DATE_FORMAT),
        policyBreakup: pCancelPolicy.policyBreakup,
      };

      returnValue = body;
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.API_CREATE_HOTEL_CANCELLATION_POLICY,
        "error in building body for Create Hotel  Cancellation policy",
        err.toString(),
        "buildRequest",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
    return returnValue;
  }

  static async getResponse(pReqOptions) {
    let returnValue = null;
    try {
      returnValue = await HttpPost.makeHttpPostRequest(
        SERVICE_URL.API_CREATE_HOTEL_CANCELLATION_POLICY,
        pReqOptions
      );
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.API_CREATE_HOTEL_CANCELLATION_POLICY,
        "error in getting Response from Create Hotel Cancellation policy",
        err.toString(),
        "getResponse",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
    return returnValue;
  }
}
